import React from "react";
import LandingSliders from "../sections/LandingSliders";
import PopularCategories from "../sections/PopularCategories";
import PopularProduct from "../sections/PopularProduct";
import SliderSecion from "../sections/SliderSecion";
import OffersSection from "../sections/OffersSection";
import ShopByBrand from "../sections/ShopByBrand";
import Accessories from "../sections/Accessories";

export default function Home() {
    return (
        <section>
            <LandingSliders />
            <PopularCategories />
            <Accessories />
            <ShopByBrand />
            <PopularProduct />
            <SliderSecion />
            <OffersSection />
        </section>
    );
}